import { render } from "./FAQArticle.vue?vue&type=template&id=4898d3b1"
import script from "./FAQArticle.vue?vue&type=script&lang=js"
export * from "./FAQArticle.vue?vue&type=script&lang=js"
script.render = render

export default script